<template>
  <div>
    <div class="l-container">
      <div class="gallery">
        <h1 class="lower-title">Advertising, Artist</h1>
        <ul class="gallery-list">
          <li v-for="(img, index) in images" :key="index" class="gallery-list__item js-lazyload">
            <a :href="img.src" class="js-luminous-media">
              <img :src="img.thumb" width="860" height="545" :alt="img.caption" />
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import galleryMixin from '../mixins/gallery';

export default {
  name: 'AdvertisingArtist',
  data: function() {
    return {
      title: 'Les Couleurs',
      description: '',
      images: [
        {
          thumb: 'images/advertising/advertisingthumb_001.jpg',
          src: 'images/advertising/advertising_001.jpg',
          caption: 'Advertising, Artist 01'
        },
        {
          thumb: 'images/advertising/advertisingthumb_002.jpg',
          src: 'images/advertising/advertising_002.jpg',
          caption: 'Advertising, Artist 02'
        },
        {
          thumb: 'images/advertising/advertisingthumb_003.jpg',
          src: 'images/advertising/advertising_003.jpg',
          caption: 'Advertising, Artist 03'
        },
        {
          thumb: 'images/advertising/advertisingthumb_004.jpg',
          src: 'images/advertising/advertising_004.jpg',
          caption: 'Advertising, Artist 04'
        },
        {
          thumb: 'images/advertising/advertisingthumb_005.jpg',
          src: 'images/advertising/advertising_005.jpg',
          caption: 'Advertising, Artist 05'
        },
        {
          thumb: 'images/advertising/advertisingthumb_006.jpg',
          src: 'images/advertising/advertising_006.jpg',
          caption: 'Advertising, Artist 06'
        },
        {
          thumb: 'images/advertising/advertisingthumb_007.jpg',
          src: 'images/advertising/advertising_007.jpg',
          caption: 'Advertising, Artist 07'
        },
        {
          thumb: 'images/advertising/advertisingthumb_008.jpg',
          src: 'images/advertising/advertising_008.jpg',
          caption: 'Advertising, Artist 08'
        },
        {
          thumb: 'images/advertising/advertisingthumb_009.jpg',
          src: 'images/advertising/advertising_009.jpg',
          caption: 'Advertising, Artist 09'
        },
        {
          thumb: 'images/advertising/advertisingthumb_010.jpg',
          src: 'images/advertising/advertising_010.jpg',
          caption: 'Les Couleur 10'
        },
        {
          thumb: 'images/advertising/advertisingthumb_011.jpg',
          src: 'images/advertising/advertising_011.jpg',
          caption: 'Advertising, Artist 11'
        },
        {
          thumb: 'images/advertising/advertisingthumb_012.jpg',
          src: 'images/advertising/advertising_012.jpg',
          caption: 'Advertising, Artist 12'
        },
        {
          thumb: 'images/advertising/advertisingthumb_013.jpg',
          src: 'images/advertising/advertising_013.jpg',
          caption: 'Advertising, Artist 13'
        },
        {
          thumb: 'images/advertising/advertisingthumb_014.jpg',
          src: 'images/advertising/advertising_014.jpg',
          caption: 'Advertising, Artist 14'
        },
        {
          thumb: 'images/advertising/advertisingthumb_015.jpg',
          src: 'images/advertising/advertising_015.jpg',
          caption: 'Advertising, Artist 15'
        },
        {
          thumb: 'images/advertising/advertisingthumb_016.jpg',
          src: 'images/advertising/advertising_016.jpg',
          caption: 'Advertising, Artist 16'
        },
        {
          thumb: 'images/advertising/advertisingthumb_017.jpg',
          src: 'images/advertising/advertising_017.jpg',
          caption: 'Advertising, Artist 17'
        },
        {
          thumb: 'images/advertising/advertisingthumb_018.jpg',
          src: 'images/advertising/advertising_018.jpg',
          caption: 'Advertising, Artist 18'
        },
        {
          thumb: 'images/advertising/advertisingthumb_019.jpg',
          src: 'images/advertising/advertising_019.jpg',
          caption: 'Advertising, Artist 19'
        },
        {
          thumb: 'images/advertising/advertisingthumb_020.jpg',
          src: 'images/advertising/advertising_020.jpg',
          caption: 'Advertising, Artist 20'
        },
        {
          thumb: 'images/advertising/advertisingthumb_021.jpg',
          src: 'images/advertising/advertising_021.jpg',
          caption: 'Advertising, Artist 21'
        },
        {
          thumb: 'images/advertising/advertisingthumb_022.jpg',
          src: 'images/advertising/advertising_022.jpg',
          caption: 'Advertising, Artist 22'
        },
        {
          thumb: 'images/advertising/advertisingthumb_023.jpg',
          src: 'images/advertising/advertising_023.jpg',
          caption: 'Advertising, Artist 23'
        },
        {
          thumb: 'images/advertising/advertisingthumb_024.jpg',
          src: 'images/advertising/advertising_024.jpg',
          caption: 'Advertising, Artist 24'
        },
        {
          thumb: 'images/advertising/advertisingthumb_025.jpg',
          src: 'images/advertising/advertising_025.jpg',
          caption: 'Advertising, Artist 25'
        },
        {
          thumb: 'images/advertising/advertisingthumb_026.jpg',
          src: 'images/advertising/advertising_026.jpg',
          caption: 'Advertising, Artist 26'
        },
        {
          thumb: 'images/advertising/advertisingthumb_027.jpg',
          src: 'images/advertising/advertising_027.jpg',
          caption: 'Advertising, Artist 27'
        },
        {
          thumb: 'images/advertising/advertisingthumb_028.jpg',
          src: 'images/advertising/advertising_028.jpg',
          caption: 'Advertising, Artist 28'
        },
        {
          thumb: 'images/advertising/advertisingthumb_029.jpg',
          src: 'images/advertising/advertising_029.jpg',
          caption: 'Advertising, Artist 29'
        },
        {
          thumb: 'images/advertising/advertisingthumb_030.jpg',
          src: 'images/advertising/advertising_030.jpg',
          caption: 'Les Couleur 30'
        },
        {
          thumb: 'images/advertising/advertisingthumb_031.jpg',
          src: 'images/advertising/advertising_031.jpg',
          caption: 'Advertising, Artist 31'
        },
        {
          thumb: 'images/advertising/advertisingthumb_032.jpg',
          src: 'images/advertising/advertising_032.jpg',
          caption: 'Advertising, Artist 32'
        },
        {
          thumb: 'images/advertising/advertisingthumb_033.jpg',
          src: 'images/advertising/advertising_033.jpg',
          caption: 'Advertising, Artist 33'
        },
        {
          thumb: 'images/advertising/advertisingthumb_034.jpg',
          src: 'images/advertising/advertising_034.jpg',
          caption: 'Advertising, Artist 34'
        },
        {
          thumb: 'images/advertising/advertisingthumb_035.jpg',
          src: 'images/advertising/advertising_035.jpg',
          caption: 'Advertising, Artist 35'
        },
        {
          thumb: 'images/advertising/advertisingthumb_036.jpg',
          src: 'images/advertising/advertising_036.jpg',
          caption: 'Advertising, Artist 36'
        },
        {
          thumb: 'images/advertising/advertisingthumb_037.jpg',
          src: 'images/advertising/advertising_037.jpg',
          caption: 'Advertising, Artist 37'
        },
        {
          thumb: 'images/advertising/advertisingthumb_038.jpg',
          src: 'images/advertising/advertising_038.jpg',
          caption: 'Advertising, Artist 38'
        },
        {
          thumb: 'images/advertising/advertisingthumb_039.jpg',
          src: 'images/advertising/advertising_039.jpg',
          caption: 'Advertising, Artist 39'
        },
        {
          thumb: 'images/advertising/advertisingthumb_040.jpg',
          src: 'images/advertising/advertising_040.jpg',
          caption: 'Advertising, Artist 40'
        },
        {
          thumb: 'images/advertising/advertisingthumb_041.jpg',
          src: 'images/advertising/advertising_041.jpg',
          caption: 'Advertising, Artist 41'
        },
        {
          thumb: 'images/advertising/advertisingthumb_042.jpg',
          src: 'images/advertising/advertising_042.jpg',
          caption: 'Advertising, Artist 42'
        },
        {
          thumb: 'images/advertising/advertisingthumb_043.jpg',
          src: 'images/advertising/advertising_043.jpg',
          caption: 'Advertising, Artist 43'
        },
        {
          thumb: 'images/advertising/advertisingthumb_044.jpg',
          src: 'images/advertising/advertising_044.jpg',
          caption: 'Advertising, Artist 44'
        },
        {
          thumb: 'images/advertising/advertisingthumb_045.jpg',
          src: 'images/advertising/advertising_045.jpg',
          caption: 'Advertising, Artist 45'
        },
        {
          thumb: 'images/advertising/advertisingthumb_046.jpg',
          src: 'images/advertising/advertising_046.jpg',
          caption: 'Advertising, Artist 46'
        },
        {
          thumb: 'images/advertising/advertisingthumb_047.jpg',
          src: 'images/advertising/advertising_047.jpg',
          caption: 'Advertising, Artist 47'
        },
        {
          thumb: 'images/advertising/advertisingthumb_048.jpg',
          src: 'images/advertising/advertising_048.jpg',
          caption: 'Advertising, Artist 48'
        },
        {
          thumb: 'images/advertising/advertisingthumb_057.jpg',
          src: 'images/advertising/advertising_057.jpg',
          caption: 'Advertising, Artist 57'
        },
        {
          thumb: 'images/advertising/advertisingthumb_049.jpg',
          src: 'images/advertising/advertising_049.jpg',
          caption: 'Advertising, Artist 49'
        },
        {
          thumb: 'images/advertising/advertisingthumb_050.jpg',
          src: 'images/advertising/advertising_050.jpg',
          caption: 'Les Couleur 50'
        },
        {
          thumb: 'images/advertising/advertisingthumb_051.jpg',
          src: 'images/advertising/advertising_051.jpg',
          caption: 'Advertising, Artist 51'
        },
        {
          thumb: 'images/advertising/advertisingthumb_052.jpg',
          src: 'images/advertising/advertising_052.jpg',
          caption: 'Advertising, Artist 52'
        },
        {
          thumb: 'images/advertising/advertisingthumb_053.jpg',
          src: 'images/advertising/advertising_053.jpg',
          caption: 'Advertising, Artist 53'
        },
        {
          thumb: 'images/advertising/advertisingthumb_054.jpg',
          src: 'images/advertising/advertising_054.jpg',
          caption: 'Advertising, Artist 54'
        },
        {
          thumb: 'images/advertising/advertisingthumb_055.jpg',
          src: 'images/advertising/advertising_055.jpg',
          caption: 'Advertising, Artist 55'
        },
        {
          thumb: 'images/advertising/advertisingthumb_056.jpg',
          src: 'images/advertising/advertising_056.jpg',
          caption: 'Advertising, Artist 56'
        },
      ]
    };
  },
  mixins: [galleryMixin],
  mounted() {
    const _lazyLoadTargets = document.querySelectorAll('.js-lazyload');
    const _luminousTargets = document.querySelectorAll('.js-luminous-media');
    this.setMeta(this.title, this.description);
    this.startUpLazyLoad(_lazyLoadTargets);
    this.startUpLuminous(_luminousTargets);
  }
};
</script>
